// extracted by mini-css-extract-plugin
export default {"button":"button--EXnuX","solid":"solid--ChWdZ","darker":"darker--hovyk"};